// extracted by mini-css-extract-plugin
module.exports = {"container":"PaginadorConfigModal_container__2OLuh","titleText":"PaginadorConfigModal_titleText__3-ITf","inputContainer":"PaginadorConfigModal_inputContainer__nc5Wb"};